export default [
  { path: '/txn/tax', redirect: '/payments' }
]